import { Link } from "react-router";
import { EmptyState } from "@agentsaas/ui";
import { useT } from "../app/i18n";

export function NotFound() {
  const { t } = useT();
  return (
    <EmptyState icon="globe" title={t("page.not_found")}>
      <Link to="/">{t("page.back_home")}</Link>
    </EmptyState>
  );
}
